import { createInfo } from '@liveauctioneers/hammer-ui-core/card/components/createInfo';
import { SubtleMonochromeLink } from '@liveauctioneers/hammer-ui-core/link';
import { BodyPrimary, BodySecondary } from '@liveauctioneers/hammer-ui-core/text';
import { useLocation } from 'react-router-dom';

import { useIsMobileLayout } from '@/hooks/useIsMobileLayout';
import { ItemSummary } from '@/types/item/ItemSummary';
import { ItemCardNavigationTrigger } from '@/utils/amplitude/analytics';
import { useItemCardNavigation } from '@/utils/amplitude/experiments/hooks/useItemCardNavigation';
import { getItemUrlFromSlug, getPriceResultsUrl, isPriceGuidePage } from '@/utils/urls';

export const TitleComponentSearchCard = createInfo<ItemSummary & { position: number }>({
    className: 'line-clamp-0',
    useText: ({ itemId, position, promoted, slug, slugWithLocation, title }) => {
        const { onNavigateInitiated } = useItemCardNavigation(itemId);
        const { pathname } = useLocation();
        const isOnPriceGuidePage = isPriceGuidePage(pathname);
        const isMobile = useIsMobileLayout();

        return (
            <div className="mb-xs px-xs smMin:mb-sm smMin:px-sm">
                <SubtleMonochromeLink
                    aria-label={title}
                    className="line-clamp-2 text-sm group-[.image-hover]:text-link-hover group-[.image-hover]:underline smMin:text-base"
                    href={
                        isOnPriceGuidePage
                            ? getPriceResultsUrl(slug || slugWithLocation)
                            : getItemUrlFromSlug(itemId, slugWithLocation)
                    }
                    onClick={() => {
                        onNavigateInitiated(ItemCardNavigationTrigger.TitleClick, { position, promoted });
                    }}
                    title={title}
                >
                    {isMobile ? <BodySecondary>{title}</BodySecondary> : <BodyPrimary>{title}</BodyPrimary>}
                </SubtleMonochromeLink>
            </div>
        );
    },
});
